<template>
    <HeaderNav
        :title="pageTitle"
        contact-label="Для соискателей"
        contact-phone="+7 950 953-92-92"
        contact-href="tel:+79509539292"
    />
    <section
        v-for="(row, rowIndex) in vacancyRows"
        :key="rowIndex"
        class="section_vacancies"
    >
        <div
            v-for="vacancy in row"
            :key="vacancy.title"
            class="container_vacancies"
        >
            <VacancyButton
                :title="vacancy.title"
                @apply="toggleModalVacancies(vacancy)"
            />
            <VacancyDetails
                :vacancy="vacancy"
                @apply="toggleModalVacancies(vacancy)"
            />
        </div>
    </section>

    <VacancyModal
        v-if="showModalVacancies"
        :vacancy="selectedVacancy"
        @close="closeModalVacancies"
        @submit="submitForm"
    />
    <FooterNav />
</template>

<script>
import { ref, computed, onMounted } from 'vue';

import HeaderNav from '@/modules/layout/default/components/header-nav/HeaderNav.vue';
import FooterNav from '@/modules/layout/default/components/footer-nav/FooterNav.vue';
import VacancyButton from '@/modules/vacancies/features/components/VacancyButton.vue';
import VacancyDetails from '@/modules/vacancies/features/components/VacancyDetails.vue';
import VacancyModal from '@/modules/vacancies/features/components/VacancyModal.vue';
import { API_ENDPOINTS } from '@/shared/constants';
// import img from '@/assets/background/image.svg';
// import test from '@/assets/background/test.png'

export default {
    components: {
        HeaderNav,
        FooterNav,
        VacancyButton,
        VacancyDetails,
        VacancyModal,
    },
    setup () {
        const pageTitle = ref('Вакансии');
        const showModalVacancies = ref(false);
        const selectedVacancy = ref(null);
        const vacancies = ref([]);
        const error = ref(null);
        // Раскладываем вакансии по строкам сами, а не через flex-wrap: при
        // наведении карточка расширяется с 25% до 38.58%, а перенос во flex
        // считается по ширине карточки, а не по её min-width. С wrap это
        // выкидывало бы четвёртую карточку строки вниз на каждое наведение.
        // Отдельная секция на строку оставляет аккордеон ровно таким, каким он
        // был, когда вакансий было всего четыре.
        const VACANCIES_PER_ROW = 4;

        const vacancyRows = computed(() => {
            const rows = [];

            for (let i = 0; i < vacancies.value.length; i += VACANCIES_PER_ROW) {
                rows.push(vacancies.value.slice(i, i + VACANCIES_PER_ROW));
            }

            return rows;
        });
        // const vacancies = [
        //     { title: 'Менеджер отдела снабжения', salary: 'От 30 000 рублей', img:img },
        //     { title: 'Вакансия-2', salary: 'От 30 000 рублей', img:img },
        //     { title: 'Вакансия-3', salary: 'От 30 000 рублей', img:img },
        //     { title: 'Вакансия-4', salary: 'От 30 000 рублей', img:img},
        // ];

        onMounted(async () => {
            try {
                const response = await fetch(API_ENDPOINTS.VACANCIES);

                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }

                const data = await response.json();

                vacancies.value = data.items;
                console.log(vacancies.value);
            } catch (e) {
                error.value = e.message;
                console.log(error.value);
            }
        });

        const toggleModalVacancies = (vacancy) => {
            if (showModalVacancies.value && selectedVacancy.value === vacancy) {
                closeModalVacancies();
            } else {
                selectedVacancy.value = vacancy;
                showModalVacancies.value = true;
                document.body.classList.add('no-scroll');
                document
                    .querySelector('.section_header')
                    .classList.add('z-index-0');
            }
        };

        const closeModalVacancies = () => {
            showModalVacancies.value = false;
            selectedVacancy.value = null;
            document.body.classList.remove('no-scroll');
            document
                .querySelector('.section_header')
                .classList.remove('z-index-0');
        };

        // Сама отправка происходит в VacancyModal - здесь только закрываем
        // модалку после подтверждённого успеха
        const submitForm = () => {
            closeModalVacancies();
        };

        return {
            pageTitle,
            showModalVacancies,
            selectedVacancy,
            vacancies,
            vacancyRows,
            toggleModalVacancies,
            closeModalVacancies,
            submitForm,
        };
    },
};
</script>
